import { create } from 'zustand';
import type { User } from '@supabase/supabase-js';

interface SubscriptionInfo {
  tier: 'free' | 'basic' | 'premium' | 'pro';
  status: 'active' | 'inactive' | 'cancelled';
  expiresAt?: string;
}

interface AuthState {
  user: User | null;
  subscription: SubscriptionInfo | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  setUser: (user: User | null) => void;
  setSubscription: (subscription: SubscriptionInfo | null) => void;
  setLoading: (loading: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  subscription: null,
  isLoading: true,
  isAuthenticated: false,
  setUser: (user) =>
    set({
      user,
      isAuthenticated: !!user,
      isLoading: false,
    }),
  setSubscription: (subscription) => set({ subscription }),
  setLoading: (loading) => set({ isLoading: loading }),
  logout: () =>
    set({
      user: null,
      subscription: null,
      isAuthenticated: false,
      isLoading: false,
    }),
}));
